import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import userIcon from '../../../assets/img/nick-user2.png';
import arrowDown from '../../../assets/img/arrow-down.svg';
import { ProjectListStrings } from '../strings/ProjectStrings';
import { getDaysUntilMidnight, getPackClass, updateUserDetails } from 'utils/Helpers';
import { useAuth } from 'contexts/AuthContext';

const ProfileModalContent = ({
  subInfo,
  profileUrl,
  formValues,
  isVerified,
  toggleModal,
  userRole,
  hasPermission,
  logout,
  templateBackUrl,
  setError,
  setLoading
}) => {
  const { isOwner, isUser1, isDark: contextIsDark } = useAuth();
  const [isDarkTheme, setIsDarkTheme] = useState(() => {
    const saved = localStorage.getItem('theme');
    if (saved === 'dark') return true;
    if (saved === 'light') return false;
    return Boolean(contextIsDark);
  });
  const isActive = subInfo?.isActive;
  const navigate = useNavigate();
  const handleClick = (e) => {
    if (isOwner && !isActive) e.preventDefault();
  };

  const toggleTheme = () => {
    setIsDarkTheme((prev) => {
      const next = !prev;
      const payload = { appTheme: next ? 'dark' : 'light', isTotorialVisited: true };
      updateUserDetails(payload, setError, setLoading, false);
      return next;
    });
  };

  const getClass = () => (isUser1 ? (isActive ? '' : 'opacity06') : '');

  const NavLinkItem = ({ to, href, text, children, isAnchor = false, extra = null }) => {
    const commonProps = {
      onClick: handleClick,
      className: getClass()
    };

    return isAnchor ? (
      <a href={href} {...commonProps}>
        {text}
        {children}
      </a>
    ) : (
      <Link to={to} {...commonProps}>
        {text}
        {extra}
        {children}
      </Link>
    );
  };

  const navLinks = [
    // { to: '/templates', text: ProjectListStrings.templatesLibraryText },
    { to: '/comingsoon', text: ProjectListStrings.resourcesText },
    ...(hasPermission(userRole, 'modify_team')
      ? [{ to: '/client-directory', text: ProjectListStrings.clientDirectoryText }]
      : [])
  ];

  const fallbackLinks = [
    { href: '#', text: ProjectListStrings.supportText },
    { href: '#', text: ProjectListStrings.whatsNewText }
  ];

  const commonImage = <img src={arrowDown} alt={ProjectListStrings.arrowIconAlt} />;

  useEffect(() => {
    const saved = localStorage.getItem('theme');
    if (saved === 'dark') {
      setIsDarkTheme(true);
    }
  }, []);

  useEffect(() => {
    if (isDarkTheme) {
      document.body.classList.add('dark_theme');
      localStorage.setItem('theme', 'dark');
    } else {
      localStorage.setItem('theme', 'light');
      document.body.classList.remove('dark_theme');
    }
  }, [isDarkTheme]);
  return (
    <>
      <div className="usee-deatils profilepic-cover">
        {profileUrl || formValues?.profilePic ? (
          <img src={profileUrl || formValues?.profilePic} alt={ProjectListStrings.userImageAlt} className="user-pic" />
        ) : (
          <img src={userIcon} alt={ProjectListStrings.userImageAlt} className="user-pic" />
        )}
        <div className="profilepic-details">
          <h2>{formValues?.fullName}</h2>
          <p>{formValues?.email}</p>
        </div>
      </div>
      <div className="profile-details">
        <a className="edit-profile" onClick={() => toggleModal('updateProfile', true)}>
          {ProjectListStrings.editProfileText}
          {(!isVerified.isEmailVerified || !isVerified.isPhoneNumberVerified) && (
            <p className="verify">{ProjectListStrings.verifyText}</p>
          )}
          <img src={arrowDown} alt={ProjectListStrings.arrowIconAlt} />
        </a>
        {hasPermission(userRole, 'update_projects') ? (
          <>
            <a
              className={getClass()}
              onClick={(e) => {
                if (isOwner && !isActive) {
                  e.preventDefault();
                } else {
                  navigate(`/templates`, {
                    state: {
                      backUrl: templateBackUrl
                    }
                  });
                }
              }}>
              {ProjectListStrings.templatesLibraryText}
            </a>
            {navLinks.map(({ to, text }) => (
              <NavLinkItem key={to} to={to} text={text}>
                {commonImage}
              </NavLinkItem>
            ))}

            {hasPermission(userRole, 'modify_team') && (
              <NavLinkItem to="/myteam" text={ProjectListStrings.myTeamText}>
                <p>{formValues?.companyName !== 'undefined' ? formValues?.companyName : ''}</p>
                {commonImage}
              </NavLinkItem>
            )}
          </>
        ) : (
          <>
            {fallbackLinks.map(({ href, text }) => (
              <NavLinkItem key={text} href={href} text={text} isAnchor>
                {commonImage}
              </NavLinkItem>
            ))}
          </>
        )}

        <NavLinkItem to="/settings" text={ProjectListStrings.settingsText}>
          {commonImage}
        </NavLinkItem>

        <NavLinkItem to="/integrations" text="Integrations">
          {commonImage}
        </NavLinkItem>

        {hasPermission(userRole, 'plan_details') && isOwner && (
          <Link to="/my-plan" className="modal-buttons">
            {ProjectListStrings.myPlanText}
            <div>
              <span className={`${getPackClass(subInfo?.status, subInfo?.isActive)} mr-2`}>
                {isActive
                  ? subInfo?.status === 'in_trial'
                    ? `Trial (${getDaysUntilMidnight(subInfo?.trialEnd || subInfo?.trial?.endsAt)} days left)`
                    : subInfo?.planDetails?.external_name
                  : 'Subscribe'}
              </span>
              {commonImage}
            </div>
          </Link>
        )}

        {isUser1 && (
          <NavLinkItem to="/analytics" text={ProjectListStrings.analyticsText}>
            {commonImage}
          </NavLinkItem>
        )}

        <NavLinkItem to="/support" text={ProjectListStrings.supportText}>
          {commonImage}
        </NavLinkItem>
        <a>
          Dark/light
          <div className="form-switch">
            <input type="checkbox" checked={isDarkTheme} onChange={toggleTheme} hidden="hidden" id="themeToggle" />
            <label className="switch" htmlFor="themeToggle"></label>
          </div>
        </a>
        <a href="#" className="logout" onClick={logout}>
          {ProjectListStrings.logoutText}
          {commonImage}
        </a>
      </div>
    </>
  );
};

export default ProfileModalContent;
